module.exports = __webpack_public_path__ + "media/כסא.01c44d28.mp3";